// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const blockText = "CreditAccountsDetailsModule__blockText__koLEN";
export const bold = "700";
export const buttonContainer = "CreditAccountsDetailsModule__buttonContainer__oLepW";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const notVerifiedBlock = "CreditAccountsDetailsModule__notVerifiedBlock__5xw9E";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";